export default __webpack_public_path__ + "static/media/032-bank.3df47a7f.svg";